<template>
  <el-input :placeholder="placeholder" :type="passwordType" :value="currentValue" @input="handleInput">
    <el-tooltip slot="suffix" :content="passwordTooltip">
      <i :class="'el-input__icon ' + passwordIcon" @click="handleIconClick"></i>
    </el-tooltip>
  </el-input>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      required: false,
    },
    placeholder: String,
    showpass: [Boolean],
  },
  data() {
    return {
      showPassword:
        this.showpass === undefined || this.showpass === null
          ? false
          : this.showpass,
      currentValue:
        this.value === undefined || this.value === null ? "" : this.value,
    };
  },
  computed: {
    passwordType: function () {
      if (this.showPassword) {
        return "text";
      }

      return "password";
    },
    passwordIcon: function () {
      if (this.showPassword) {
        return "el-icon-scs-yincangmima";
      }

      return "el-icon-scs-xianshimima";
    },
    passwordTooltip: function () {
      if (this.showPassword) {
        return "隐藏密码";
      }

      return "显示密码";
    },
  },
  created() {
    this.setShowPassword();
    this.setCurrentValue();
  },
  methods: {
    setShowPassword(value) {
      if (value === undefined) value = !!this.showpass;

      this.showPassword = value;
    },
    setCurrentValue(value) {
      if (!value) value = this.value;

      this.currentValue = value;
    },
    handleIconClick(event) {
      this.showPassword = !this.showPassword;
      this.$emit("shown-changed", this.showPassword);
    },
    handleInput(newVal) {
      this.setCurrentValue(newVal);
      this.$emit("input", newVal);
    },
  },
  watch: {
    value: function (newVal) {
      this.setCurrentValue(newVal);
    },
    showpass: function (newVal) {
      this.setShowPassword(newVal);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/el-scs-password.vue